<template>
  <div class="songplay">
    <div class="row">
      <div class="left col-md-8 float-left pl-0 pr-0">
        <player @modalMessage="modalMessage=$event"></player>
      </div>

      <div class="right col-md-4 float-right pr-1 pl-1 mt-4">
        <other-album></other-album>
      </div>
      <div class="parent expand" style="clear: both"></div>
    </div>

    <div>
      <partner></partner>
    </div>

    <modal :modal-title="modalTitle" :modal-message="modalMessage"></modal>
  </div>
</template>

<script>
  import Player from './Player'
  import Partner from '../../home/wap/Partner'
  import OtherAlbum from './OtherAlbum'

  export default {
    name: "SongPlay",
    components: {
      "player": Player,
      "partner": Partner,
      "other-album": OtherAlbum
    },
    data () {
      return {
        modalTitle: "Thông báo",
        modalMessage: null
      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .right{
    margin-top: -15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/albumplay/wap/AlbumPlay.vue